/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetGipAltReportExportStatusQueryResponse, AuditReportsGetGipAltReportExportStatusPathParams, AuditReportsGetGipAltReportExportStatus401, AuditReportsGetGipAltReportExportStatus403, AuditReportsGetGipAltReportExportStatus404 } from "../models/AuditReportsGetGipAltReportExportStatus";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { auditReportsGetGipAltReportExportStatus } from "../axios/auditReportsGetGipAltReportExportStatus";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const auditReportsGetGipAltReportExportStatusQueryKey = (id: AuditReportsGetGipAltReportExportStatusPathParams["id"]) => ["api-v2", { url: '/audit-reports/v1/reports/gip-alt/report/:id/export-status', params: {id:id} }] as const

export type AuditReportsGetGipAltReportExportStatusQueryKey = ReturnType<typeof auditReportsGetGipAltReportExportStatusQueryKey>

export function auditReportsGetGipAltReportExportStatusQueryOptions(id: AuditReportsGetGipAltReportExportStatusPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = auditReportsGetGipAltReportExportStatusQueryKey(id)
        return queryOptions<AuditReportsGetGipAltReportExportStatusQueryResponse, ResponseErrorConfig<AuditReportsGetGipAltReportExportStatus401 | AuditReportsGetGipAltReportExportStatus403 | AuditReportsGetGipAltReportExportStatus404>, AuditReportsGetGipAltReportExportStatusQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return auditReportsGetGipAltReportExportStatus(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get export job status for report
 * {@link /audit-reports/v1/reports/gip-alt/report/:id/export-status}
 */
export function useAuditReportsGetGipAltReportExportStatus<TData = AuditReportsGetGipAltReportExportStatusQueryResponse, TQueryData = AuditReportsGetGipAltReportExportStatusQueryResponse, TQueryKey extends QueryKey = AuditReportsGetGipAltReportExportStatusQueryKey>(id: AuditReportsGetGipAltReportExportStatusPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<AuditReportsGetGipAltReportExportStatusQueryResponse, ResponseErrorConfig<AuditReportsGetGipAltReportExportStatus401 | AuditReportsGetGipAltReportExportStatus403 | AuditReportsGetGipAltReportExportStatus404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? auditReportsGetGipAltReportExportStatusQueryKey(id)
         

         const query = useQuery({
          ...auditReportsGetGipAltReportExportStatusQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AuditReportsGetGipAltReportExportStatus401 | AuditReportsGetGipAltReportExportStatus403 | AuditReportsGetGipAltReportExportStatus404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}